import { useEffect, useState } from 'react';

import { Input } from '@chakra-ui/react';

import { isNotDefined } from '@enterprise/core';

import type { NotesCellProps } from './types/notes-cell.props';

const NotesCell = ({ context, data }: NotesCellProps) => {
  const [localValue, setLocalValue] = useState<string>(data?.notes ?? '');

  useEffect(() => {
    setLocalValue(data?.notes ?? '');
  }, [data?.notes]);

  if (isNotDefined(data)) {
    return null;
  }

  return (
    <Input
      onBlur={() => {
        context.handleRowUpdate(data.mailingListId, { notes: localValue });
      }}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
      placeholder="Notes…"
      size="xs"
      value={localValue}
    />
  );
};

export default NotesCell;
